export default __webpack_public_path__ + "static/image_contact@2x-2ecd4e9d7b2a2c80c02ecb3b28874ccc.jpg";